import Button from "@/components/Common/Button";
import PaymentFailedContent from "@/components/Common/payment/PaymentFailedContent";
import type {InvoiceSerializer} from "@/generated/DjangoTypes";
import {useFailedInvoicePayment} from "@/hooks/useFailedInvoicePayment";
import {usePriceFormat} from "@/hooks/usePriceFormat";
import {Can} from "@/permissions";
import {useSettingsCompanyStore} from "@/store/company";
import type {FC} from "react";
import {useTranslation} from "react-i18next";

const PaymentFailedSubview: FC<{invoices: InvoiceSerializer[]; onPaid(): void}> = ({invoices, onPaid}) => {
  const {t} = useTranslation("common");
  const company = useSettingsCompanyStore(state => state.company);
  const payment = useFailedInvoicePayment({invoices, onPaid});
  const formatPrice = usePriceFormat({currency: payment.currency});

  return (
    <div className="flex flex-col gap-8">
      <PaymentFailedContent
        actionButtonClassName="h-10 px-5 text-sm sm:min-w-0"
        billingDetails={{
          city: company.address_city,
          country: company.country,
          phone: company.phonenumber,
          postalCode: company.address_postal,
          street: company.address_street,
        }}
        dividerClassName="mx-0"
        headingClassName="text-neutral-black text-sm leading-normal font-medium"
        invoices={invoices}
        payment={payment}
      />
      <div className="flex flex-wrap items-center gap-3">
        <div className="flex flex-col gap-1">
          <span className="text-neutral-grey-dark text-xs">{t("amount_due")}</span>
          <span className="text-neutral-black text-lg leading-none font-bold">{formatPrice(payment.totalAmount)}</span>
        </div>
        <Can I="list" a="CompanyPaymentMethod">
          <Button
            buttonStyle="Gradient"
            className="ml-auto h-10 flex-1 px-5 text-sm sm:flex-none"
            isDisabled={payment.isPayDisabled}
            onClick={payment.pay}>
            {t("pay")}
          </Button>
        </Can>
      </div>
    </div>
  );
};

export default PaymentFailedSubview;
